import React, { memo } from 'react';
import { PhoneIcon, MessageSquareIcon, SearchIcon, GlobeIcon, BrainIcon } from 'lucide-react';
const HowItWorks = () => {
  const steps = [{
    title: 'User Makes Contact',
    description: "Send an SMS text or dial the AI's local phone number like a friend or family member.",
    icon: <PhoneIcon className="h-8 w-8 text-white" data-id="element-108" />
  }, {
    title: 'Voice or Text Interaction',
    description: 'The communication is delivered on the mobile operator network, reachable even without a mobile data connection.',
    icon: <MessageSquareIcon className="h-8 w-8 text-white" data-id="element-109" />
  }, {
    title: 'AI Inference',
    description: 'Voxie connects the query to the latest large language and foundation models, with memory, multi-language capabilities, and contextual understanding.',
    icon: <BrainIcon className="h-8 w-8 text-white" data-id="element-110" />
  }, {
    title: 'Web Search & Integration',
    description: 'If needed, Voxie can perform web searches and integrate with other services to provide comprehensive and up-to-date responses.',
    icon: <SearchIcon className="h-8 w-8 text-white" data-id="element-111" />
  }, {
    title: 'Instant Response',
    description: 'The AI response is delivered back to the user via the same channel they used to contact Voxie.',
    icon: <GlobeIcon className="h-8 w-8 text-white" data-id="element-112" />
  }];
  return <section id="how-it-works" className="py-16 bg-gray-50" data-id="element-113">
      <div className="container mx-auto px-4" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl font-bold mb-4" data-id="element-116">How Voxie Works</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-117">
            Voxie enables anyone with a phone number to text and call AI. It
            even work for feature (non-smart-) phones. No need to go to website
            or install an app. It's just another contact in your text and call
            history.
          </p>
        </div>
        {/* Mobile Timeline (Vertical) */}
        <div className="md:hidden relative" data-id="element-118">
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-[#c4eeeb]" data-id="element-119"></div>
          <div className="space-y-12" data-id="element-120">
            {steps.map((step, index) => <div key={index} className="flex items-start" data-id="element-121">
                <div className="bg-[#54d4cb] rounded-full p-4 z-10 mr-6 flex-shrink-0" data-id="element-122">
                  {step.icon}
                </div>
                <div className="pt-2" data-id="element-123">
                  <h3 className="text-xl font-bold mb-2" data-id="element-124">{step.title}</h3>
                  <p className="text-gray-600" data-id="element-125">{step.description}</p>
                </div>
              </div>)}
          </div>
        </div>
        {/* Desktop Timeline (Alternating) */}
        <div className="hidden md:block relative" data-id="element-126">
          <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-[#c4eeeb] transform -translate-x-1/2" data-id="element-127"></div>
          <div className="space-y-16" data-id="element-128">
            {steps.map((step, index) => <div key={index} className="relative flex items-center" data-id="element-129">
                {/* Left side (even steps) */}
                {index % 2 === 0 ? <>
                    <div className="w-1/2 pr-12 text-right" data-id="element-130">
                      <h3 className="text-2xl font-bold mb-3" data-id="element-131">{step.title}</h3>
                      <p className="text-gray-600" data-id="element-132">{step.description}</p>
                    </div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 z-10 bg-[#54d4cb] rounded-full p-4" data-id="element-133">
                      {step.icon}
                    </div>
                    <div className="w-1/2 pl-12" data-id="element-134"></div>
                  </> :
            // Right side (odd steps)
            <>
                    <div className="w-1/2 pr-12" data-id="element-135"></div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 z-10 bg-[#54d4cb] rounded-full p-4" data-id="element-136">
                      {step.icon}
                    </div>
                    <div className="w-1/2 pl-12 text-left" data-id="element-137">
                      <h3 className="text-2xl font-bold mb-3" data-id="element-138">{step.title}</h3>
                      <p className="text-gray-600" data-id="element-139">{step.description}</p>
                    </div>
                  </>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default HowItWorks;